/**
 * Key Ingredients - Slider & Accordion
 */

document.addEventListener('DOMContentLoaded', () => {
  // Slider elements
  const sliderEl = document.querySelector('.js-research-ingredients-slider');
  let researchIngredientsSlider = null;

  // Accordion elements
  const accordionEl = document.querySelector('.js-key-ingredients-accordion');
  const tableBodyEl = document.querySelector('.js-key-ingredients-body');

  // Shared function to get variant metafields
  function getVariantMetafields(variantId) {
    const metafieldsScript = document.querySelector('[data-variant-metafields]');
    if (!metafieldsScript) return null;

    try {
      const metafieldsData = JSON.parse(metafieldsScript.textContent);
      const variantData = metafieldsData.find(v => v.id === variantId);
      return variantData ? variantData.metafields : null;
    } catch (e) {
      console.error('Error parsing variant metafields:', e);
      return null;
    }
  }

  // Function to build slides from variant metafields
  function buildSlides(metafields) {
  if (!metafields || !window.key_ingredients) return '';

  const slides = [];

  for (let i = 1; i <= 4; i++) {
    const fieldName = `key_ingredients_option_${i}`;
    const ingredientKey = metafields[fieldName];

    if (ingredientKey && window.key_ingredients[ingredientKey]) {
      const ingredient = window.key_ingredients[ingredientKey];
      const farmTag = ingredient.source === 'POSSIBLE Farm, WI'
        ? `<span class="ingredient-farm-tag">HARVESTED ON OUR FARM</span>`
        : '';

      slides.push(`
        <div class="swiper-slide">
          <div class="tile" style="--bg-image: url(${ingredient.main_image});">
            ${farmTag}
            <div>
              <h4>${ingredient.title}</h4>
              <p>${ingredient.description}</p>
            </div>
          </div>
        </div>
      `);
    }
  }

    return slides.join('');
  }

  // Function to initialize/update slider
  function updateSlider(variantId) {
    if (!sliderEl) return;

    const metafields = getVariantMetafields(variantId);
    const slidesHTML = buildSlides(metafields);
    const sectionEl = document.querySelector('.research-ingredients');

    if (slidesHTML) {
      // Show section
      if (sectionEl) {
        sectionEl.style.display = '';
      }

      // Update slider content
      const swiperWrapper = sliderEl.querySelector('.swiper-wrapper');
      if (swiperWrapper) {
        swiperWrapper.innerHTML = slidesHTML;
      }

      // Destroy existing slider if it exists
      if (researchIngredientsSlider) {
        researchIngredientsSlider.destroy(true, true);
      }

      // Initialize new slider
      researchIngredientsSlider = new Swiper('.js-research-ingredients-slider', {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: '.research-ingredients__nav-next',
          prevEl: '.research-ingredients__nav-prev',
        },
        breakpoints: {
          769: {
            slidesPerView: 4,
            spaceBetween: 0,
            enabled: false,
          }
        }
      });
    } else {
      // Hide section if no slides
      if (sectionEl) {
        sectionEl.style.display = 'none';
      }
    }
  }

  // Function to build table rows from variant metafields
  function buildTableRows(metafields) {
    if (!metafields || !window.key_ingredients) return '';

    const rows = [];

    // Check key_ingredients_option_1 through key_ingredients_option_4
    for (let i = 1; i <= 4; i++) {
      const fieldName = `key_ingredients_option_${i}`;
      const ingredientKey = metafields[fieldName];

      if (ingredientKey && window.key_ingredients[ingredientKey]) {
        const ingredient = window.key_ingredients[ingredientKey];
        rows.push(`
          <div class="key-ingredients-row">
            <div class="key-ingredients-col-1">
              <img src="${ingredient.small_image}" alt="${ingredient.title}" class="ingredient-image">
              <span>${ingredient.title}</span>
            </div>
            <div class="key-ingredients-col-2">${ingredient.benefits}</div>
            <div class="key-ingredients-col-3">${ingredient.source}</div>
          </div>
        `);
      }
    }

    return rows.join('');
  }

  // Function to update accordion
  function updateAccordion(variantId) {
    if (!tableBodyEl || !accordionEl) return;

    const metafields = getVariantMetafields(variantId);
    const rowsHTML = buildTableRows(metafields);

    if (rowsHTML) {
      // Show accordion
      accordionEl.style.display = 'block';

      // Update table content
      tableBodyEl.innerHTML = rowsHTML;
    } else {
      // Hide accordion if no ingredients
      accordionEl.style.display = 'none';
    }
  }

  // Function to update both slider and accordion
  function updateBoth(variantId) {
    updateSlider(variantId);
    updateAccordion(variantId);
  }

  // Initialize on page load with current variant
  const currentVariantInput = document.querySelector('input[name="id"]');
  if (currentVariantInput) {
    const variantId = parseInt(currentVariantInput.value);
    if (sliderEl) updateSlider(variantId);
    if (accordionEl) updateAccordion(variantId);
  }

  // Listen for variant changes
  document.addEventListener('variant:change', (event) => {
    if (event.detail && event.detail.variant) {
      updateBoth(event.detail.variant.id);
    }
  });

  // Footer slider uses CSS animation - no JS needed
});